<template>
  <div class="development">
    <Header></Header>
    <slideshow></slideshow>
    <div class="fanhui">
      <div class="imgs" @click="Company()">
        <!-- <img src="../../assets/img/heise.png" alt="" /> -->
        返回上一页
      </div>

      <div class="xiams"></div>
    </div>

    <div class="Company_boxs">
      <p class="Company_texts">{{ title }}</p>
      <div class="arrow-rights">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">你现在所在的位置</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>资讯中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="news_box">
      <div class="user_box">
        <p class="user_text">{{ list.title }}</p>
        <div class="date_box">
          <p class="item_text">日期:{{ list.addTime }}</p>
        </div>
        <div v-html="list.content" style='white-space: pre-wrap;' class="content_text ql-editor"></div>
      </div>
      <div class="sxt">
        <span class="sxt_s" @click="tiaoshu(1)">上一条:{{ shangtitle }}</span>
        <span @click="tiaoshu(2)">下一条:{{ xiatitel }}</span>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../../components/haed/haed";
import Footer from "../../components/haed/footer";
import slideshow from "../../components/haed/slideshow";
import qs from "qs";
export default {
  name: "development",
  components: {
    Header,
    Footer,
    slideshow,
  },
  data() {
    return {
      listQuery: {
        bsId: "",
        pageNum: 1,
        pageSize: 3,
      },
      name: "1",
      go: "",
      list: [],
      title: "",
      sd: "",
      rr: "",
      shang: "",
      shangtitle: "",
      xia: "",
      xiatitel: "",
      page: "",
      xy: "",
      mt: "",
      menu: "",
      type: ""
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.menu = this.$route.query.menu;
    this.type = this.$route.query.type;
    var bid = this.$route.query.bid;
    this.name = this.$route.query.name;
    this.go = this.$route.query.bid;
    // this.page=this.$route.query.page
    this.Companynews(this.id);
    this.Companynewsb(bid);
    if (this.$route.query.sd) {
      this.sd = this.$route.query.sd;
    }
    if (this.$route.query.rr) {
      this.rr = this.$route.query.rr;
    }
    if (this.$route.query.page) {
      this.page = this.$route.query.page
    }
    if (this.$route.query.xy) {
      this.xy = this.$route.query.xy
    }
    if (this.$route.query.mt) {
      this.xy = this.$route.query.mt
    }
  },
  mounted() { },
  methods: {
    tiaoshu(s) {
      if (s == 1) {
        if (this.shang == "没有上一条") {
          this.$alert("<strong>暂无上一条数据</strong>", "提示", {
            dangerouslyUseHTMLString: true,
          });
          return;
        }
        this.getNext(this.shang);
      } else {
        if (this.xia == "没有下一条") {
          this.$alert("<strong>暂无下一条数据</strong>", "提示", {
            dangerouslyUseHTMLString: true,
          });
          return;
        }
        this.getNext(this.xia);
      }
    },
    Company() {
      if (this.sd) {
        this.$router.push({ path: "/" });
      }
      else if (this.rr) {
        this.$router.push({ path: "/index?name=" + this.rr });
      }
      //else if (this.page) {
      //   this.$router.push({ path: "/index?name=" + this.name + "&page=" + this.page });
      // } else if (this.xy) {
      //   this.$router.push({ path: "/index?name=" + this.name + "&xy=" + this.xy });
      // } else if (this.mt) {
      //   this.$router.push({ path: "/index?name=" + this.name + "&mt=" + this.mt });
      // }
      else {
        this.$router.push({ path: "/index?name=" + this.name });
      }
    },
    getShowLists() {
      this.Companynews();
    },
    Companynews: function (id) {
      this.$axios({
        // method: "post",
        // url: "/index.php/news/newsview",
        method: "get",
        url: "/changhang/index/" + id,
        // data: qs.stringify({
        //   id: id,
        //   pageNum: this.listQuery.pageNum,
        //   pageSize: 1,
        // }),
      })
        .then((res) => {

          let data = res.data.data

          this.list = data;
          console.log(data);
          console.log('aaaa');

          // this.list.createTime = list.createTime.slice(0, 10)
          console.log(data.after + "aaa");
          if (data.after) {
            this.shang = 1;
            this.shangtitle = data.after
          } else {
            this.shang = "没有上一条";
            this.shangtitle = "暂无"
          }
          if (data.next) {
            this.xia = 2;
            this.xiatitel = data.next
          } else {
            this.xia = "没有下一条";
            this.xiatitel = "暂无"
          }

          this.total = res.data.total;
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
    getNext: function (id) {
      this.$axios({
        method: "get",
        url: "/changhang/index/afterOrNext?id=" + this.id + '&menu=' + this.menu + '&type=' + this.type + '&afterOrNext=' + id,
      }).then(
        (res) => {
          this.id = res.data.data.id
          this.Companynews(this.id)
        }
      )
    },
    Companynewsb: function (bid) {
      this.$axios({
        method: "post",
        url: "/index.php/news/newsrow",
        data: qs.stringify({
          bid: bid,
        }),
      })
        .then((res) => {
          this.title = res.data.data.title;
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
  },
};
</script>
<style>
.ql-align-center img{
  display:block !important;
	margin: 0 auto !important;
}
</style>
<style scoped>
.sxt {
  /* display:flex; */

  text-align: center;
  cursor: pointer;
  margin: 1% auto;
}

.sxt_s {
  margin-right: 10%;
}

.xiams {
  position: relative;
  top: 160%;
  left: 250%;
  width: 1px;
  height: 6vw;
  background-color: #dedede;
}

.el-breadcrumb {
  font-size: 0.9vw;
  margin-top: 1%;
}

.Company_texts {
  font-weight: bold;
  font-size: 27px;
  color: #0c47a1;
  text-align: center;
  line-height: 2;
  margin-left: 10px;
  margin-top: -0.4vw;
}

.arrow-rights {
  margin-top: 2%;
  margin: 0 auto;
}

.fanhui {
  display: flex;
  width: 6vw;
  height: 3vw;
  text-align: center;
  line-height: 3vw;
  color: #000;
  font-size: 1vw;
  position: absolute;
  z-index: 9999;
}

.imgs {
  width: 6vw;
  height: 1.5vw;
  position: relative;
  top: 190%;
  left: 210%;
}

.imgs:hover {
  cursor: pointer;
}

.imgs img {
  /* width: 100%;
  height: 100%; */
  width: 80%;
  height: 70%;
}

.Company_boxs {
  display: flex;
  width: 50%;
  padding-bottom: 10px;
  margin: 0 auto;
  margin-top: 2%;
  border-bottom: 1px solid #dedede;
}

.news_box {
  /* width: 55%; */
  margin: 0 auto;
  margin-top: 2%;
}

.user_text {
  text-align: center;
  font-size: 24px;
}

.item_text {
  margin-top: 1%;
  color: #3d3d3d;
  text-align: center;
}

.content_text {
  width: 50%;
  margin: 0 auto;
  margin-top: 1%;
  margin-bottom: 1%;
  line-height: 1.5;
}
.arrow-rights {
  margin-top: 1%;
}

@media screen and (min-width: 320px) and (max-width: 750px) {
  .Company_boxs {
    display: none;
  }

  .user_text {
    font-size: 16px;
  }

  .content_text {
    width: 80%;
  }

  .fanhui {
    font-size: 12px;
    width: 200px;
    display: flex;
    position: static;

  }

  .imgs {
    position: static;
    margin-top: 10%;
    width: 100px;
  }

  .xiams {
    position: static;
    margin-top: 10%;
    display: none;
  }

  .sxt {
    margin: 0 10px;

    display: flex;
  }

  .sxt span {
    font-size: 12px;
    width: 50%;
  }

  .news_box {
    margin-top: 12%;
    /* width: 98%; */
  }

}
</style>


// WEBPACK FOOTER //
// src/pages/companynews/companynews.vue